import React from 'react';
import Attribute from './common';
import { SubText } from '../../../common';

const notice = `Buying or selling an imported car is perfectly legal.
Be sure you are aware of the implications of owning an imported vehicle.`;

interface Props {
    passed: boolean;
};

const NotImported: React.FC<Props> = ({ passed }) => (
    <Attribute name="Not imported" passed={passed}>
        <SubText>{notice}</SubText>
    </Attribute>
);

export default NotImported;
